<section [hidden]="!statusInfo.isRequireApprovalStage">
	<section layout="row" [ngClass]="styles.wrapper" [hidden]="!isVideoUploader">
		<span flex-align-self="center" class="margin-right-5 text-align-center">
			<span [ngClass]="styles.stepName">
				<span class="glyphicons circle_arrow_right"></span>
				{{ 'ApprovalWorkflow_RequestApproval' | translate }} -
			</span>
			{{ 'ApprovalWorkflow_VideoPendingMessage' | translate }}
		</span>
		<vb-ui-select class="margin-right-5" [hidden]="!showTemplateList">
			<select #selectElement name="selectedTemplateId" [(ngModel)]="approvalDetails.selectedTemplateId">
				<option [ngValue]="undefined">{{ 'SelectAProcess' | translate }}</option>
				<option *ngFor="let template of templates" [value]="template.id">{{ template.name }}</option>
			</select>
		</vb-ui-select>
		<approval-submit-btn [templateListCount]="templates.length" [isSubmitted]="isSubmitted" [isTemplateSelected]="approvalDetails.selectedTemplateId" (onApprovalSubmit)="approvalSubmit()">
		</approval-submit-btn>
	</section>
	<section layout="row" [ngClass]="styles.wrapper" [hidden]="!(isMediaAdmin && !isVideoUploader)">
		<span class="text-align-center">
			<span [ngClass]="styles.stepName">
				<span class="glyphicons circle_exclamation_mark"></span>
				{{ 'ApprovalWorkflow_VideoNotSubmitted' | translate }} -
			</span>
			{{ 'ApprovalWorkflow_VideoNotSubmittedMessage' | translate }}
		</span>
	</section>
</section>

<section layout="row" [ngClass]="styles.wrapper" [hidden]="!(statusInfo.isPendingApprovalStage && isOnlyVideoUploader)">
	<span flex-align-self="center" class="margin-right-5 text-align-center">
		<span [ngClass]="styles.stepName">
			<span class="glyphicons circle_exclamation_mark"></span>
			{{ 'ApprovalWorkflow_PendingApproval' | translate }} -
		</span>
		{{ 'ApprovalWorkflow_VideoPendingMessage' | translate }}
		<approval-submitted-details [submittedDateTime]="approvalDetails.whenSubmitted"></approval-submitted-details>
	</span>
</section>

<section layout="row" [ngClass]="styles.wrapper" [hidden]="!(statusInfo.isRejectedApprovalStage && isVideoUploader)">
	<span flex-align-self="center" class="margin-right-5 text-align-center">
		<span [ngClass]="styles.stepName">
			<span class="glyphicons circle_remove"></span>
			{{ 'VideoRejected' | translate }} -
		</span>
		{{ 'ApprovalWorkflow_VideoRejectedMessage' | translate }}
	</span>
	<vb-ui-select class="margin-right-5" [hidden]="!showTemplateList">
		<select #selectElement name="selectedTemplateId" [(ngModel)]="approvalDetails.selectedTemplateId">
			<option [ngValue]="undefined">{{ 'SelectAProcess' | translate }}</option>
			<option *ngFor="let template of templates" [value]="template.id">{{ template.name }}</option>
		</select>
	</vb-ui-select>
	<button type="button" class="margin-right-5" [hidden]="!templates" vbBtnSecondary (click)="deleteVideo()">
		{{ 'UI_DeleteVideo' | translate }}
	</button>
	<approval-submit-btn [templateListCount]="templates.length" [isSubmitted]="isSubmitted" [isTemplateSelected]="approvalDetails.selectedTemplateId" (onApprovalSubmit)="approvalSubmit()">
	</approval-submit-btn>
</section>